export default __webpack_public_path__ + "static/media/category_help.9488ba71.png";